var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    ref: "trigger"
  }, [_vm._t("default"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.effect
    }
  }, [(_vm.show && _vm.popoverCondition) ? _c('div', {
    ref: "popover",
    class: ['popover', _vm.placement],
    style: (_vm.popoverStyle)
  }, [_c('div', {
    staticClass: "arrow",
    style: (_vm.arrowStyle)
  }), _vm._v(" "), (_vm.title) ? _c('h3', {
    staticClass: "popover-title"
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2) : _vm._e(), _vm._v(" "), (_vm.content) ? _c('div', {
    staticClass: "popover-content"
  }, [_vm._t("content", [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin": "10px 0px 15px 0px"
    }
  }), _vm._v(" "), _c('input-w', {
    attrs: {
      "validation": _vm.validation
    },
    on: {
      "validateResult": _vm.checkValidateResult
    },
    model: {
      value: (_vm.dataModel),
      callback: function($$v) {
        _vm.dataModel = $$v
      },
      expression: "dataModel"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataModel),
      expression: "dataModel"
    }],
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "rows": "4",
      "cols": "40",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.dataModel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataModel = $event.target.value
      }
    }
  })])])], 2) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger btn-sm",
    staticStyle: {
      "float": "left",
      "margin": "5px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary-default btn-sm",
    staticStyle: {
      "float": "right",
      "margin": "5px"
    },
    attrs: {
      "disabled": _vm.invalid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.apply($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('ok')))])])]) : _vm._e()])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc870d94","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic/popoverWrapper/TextModifier.vue
// module id = 1558
// module chunks = 1